const siteRoot = process.env.SITE_ROOT || 'http://localhost:3000';

export default function getBaseUrl() {
  return siteRoot;
}
